export default __webpack_public_path__ + "static/media/cart.2db6e491.svg";